import { createFeatureSelector, createSelector } from "@ngrx/store";

const selectGeneratedJobIdsState = createFeatureSelector<string[]>('generatedJobIds');
export const selectGeneratedJobIds = createSelector(
  selectGeneratedJobIdsState,
  (state: string[]) => state
);
